import { Popover, Transition } from '@headlessui/react';
import { Fragment } from 'react';

import { HelpIcon } from '@/components/common/help-icon';

import { WarningIcon } from '../warning-icon';

export function InfoPopover({
  type = 'info',
  children,
}: {
  type: 'info' | 'warning';
  children: React.ReactNode;
}) {
  return (
    <Popover className="relative">
      <Popover.Button>
        {type === 'info' && <HelpIcon />}
        {type === 'warning' && <WarningIcon />}
      </Popover.Button>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-200"
        enterFrom="opacity-0 translate-y-1"
        enterTo="opacity-100 translate-y-0"
        leave="transition ease-in duration-150"
        leaveFrom="opacity-100 translate-y-0"
        leaveTo="opacity-0 translate-y-1"
      >
        <Popover.Panel className="absolute -left-60 z-10 w-[20vh] md:w-[40vh] lg:w-[50vh] bg-white border border-gray-100 drop-shadow-lg rounded-lg">
          {children}
        </Popover.Panel>
      </Transition>
    </Popover>
  );
}

export default InfoPopover;
